"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeDataPointFromObj = void 0;
const utils_1 = require("ethers/lib/utils");
const DataPoint_1 = require("./DataPoint");
const NumericDataPoint_1 = require("./NumericDataPoint");
// This function was moved to a separate file, because it was not
// possible to make it as a static method in the DataPoint class.
// It would cause circularly importing classes, which is not supported
// More info here: https://stackoverflow.com/a/44727578
const deserializeDataPointFromObj = (plainObject) => {
    if (typeof plainObject.value == "number") {
        return new NumericDataPoint_1.NumericDataPoint(plainObject);
    }
    else {
        return new DataPoint_1.DataPoint(plainObject.dataFeedId, utils_1.base64.decode(plainObject.value));
    }
};
exports.deserializeDataPointFromObj = deserializeDataPointFromObj;
//# sourceMappingURL=data-point-deserializer.js.map